var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMascotte2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 586,
    height: 344,
    viewBox: "0 0 586 344",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_263_929",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 586,
    height: 344
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 586,
    height: 344,
    rx: 15,
    fill: "#91E3FA"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_263_929)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M337.272 36.1624C397.155 33.1045 416.271 74.4336 510.737 57.2622C586.064 43.5721 618.492 94.6864 627.873 126.442C632.35 141.614 633.487 200.914 592.152 201.761C451.873 204.678 339.475 358.374 271.847 223.966C244.417 169.441 201.329 43.1251 337.272 36.1624Z",
    fill: "white",
    fillOpacity: 0.45
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M-156.728 244.162C-96.8452 241.105 -77.7292 282.434 16.7372 265.262C92.0639 251.572 124.492 302.686 133.873 334.442C138.35 349.614 139.487 408.914 98.1516 409.761C-42.1267 412.678 -154.525 566.374 -222.153 431.966C-249.583 377.441 -292.671 251.125 -156.728 244.162Z",
    fill: "white",
    fillOpacity: 0.45
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_263_929)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M402.766 327.258C402.543 360.601 432.229 397.907 469.146 398.157C506.076 398.407 536.263 361.519 536.485 328.162C536.707 294.819 506.896 277.633 469.966 277.383C433.036 277.133 402.988 293.902 402.752 327.244L402.766 327.258Z",
    fill: "url(#paint0_linear_263_929)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M517.704 294.114L517.692 294.12C510.751 297.582 507.931 306.015 511.393 312.956L528.455 347.16C531.916 354.101 540.349 356.92 547.29 353.459L547.302 353.452C554.243 349.99 557.063 341.558 553.601 334.617L536.54 300.413C533.078 293.472 524.645 290.652 517.704 294.114Z",
    fill: "url(#paint1_linear_263_929)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.795 273.901L375.784 273.909C369.322 278.199 367.562 286.914 371.851 293.376L398.545 333.584C402.835 340.046 411.551 341.806 418.013 337.517L418.024 337.509C424.486 333.219 426.247 324.503 421.957 318.042L395.263 277.833C390.973 271.372 382.257 269.611 375.795 273.901Z",
    fill: "url(#paint2_linear_263_929)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.337 191.927L406.048 178.356C399.235 174.199 390.67 174.171 383.829 178.287C372.274 185.211 363.584 196.043 359.329 208.821C352.265 229.997 361.721 253.148 381.576 263.326L403.656 274.644L428.323 191.927H428.337Z",
    fill: "#9E83FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.165 204.482L405.631 193.206C399.958 189.757 392.839 189.73 387.152 193.15C377.558 198.907 370.327 207.917 366.796 218.526C360.928 236.129 368.784 255.373 385.302 263.84L403.656 273.254L424.165 204.482Z",
    fill: "url(#paint3_linear_263_929)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M505.784 191.927L528.073 178.356C534.886 174.199 543.451 174.171 550.292 178.287C561.833 185.211 570.523 196.043 574.778 208.807C581.842 229.983 572.386 253.134 552.531 263.312L530.451 274.63L505.784 191.913V191.927Z",
    fill: "#9E83FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M509.956 204.482L528.491 193.206C534.164 189.757 541.283 189.73 546.97 193.15C556.564 198.907 563.794 207.917 567.326 218.526C573.193 236.129 565.337 255.373 548.819 263.84L530.465 273.254L509.956 204.482Z",
    fill: "url(#paint4_linear_263_929)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_263_929)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M541.45 257.653C541.45 298.74 508.148 317.164 467.061 317.164C425.973 317.164 392.672 298.74 392.672 257.653C392.672 216.565 438.529 172.446 467.061 172.446C495.593 172.446 541.45 216.565 541.45 257.653Z",
    fill: "url(#paint5_linear_263_929)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_263_929)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M451.223 177.744C457.786 182.777 457.897 197.433 457.897 197.433C458.05 197.933 458.76 197.766 458.996 197.613C460.011 196.96 462.347 194.11 462.347 194.11C462.639 193.692 463.265 193.79 463.431 194.263C463.431 194.263 464.975 199.574 465.322 204.343C465.35 204.649 466.268 204.482 466.504 204.315C468.715 202.716 470.578 193.943 470.578 193.943C470.717 193.456 471.329 193.331 471.649 193.706C471.649 193.706 474.152 194.847 475.459 198.267C475.556 198.531 476.335 198.184 476.543 197.989C480.701 194.179 483.231 179.746 480.117 175.255C475.695 168.873 445.133 173.058 451.223 177.73V177.744Z",
    fill: "#8058EA"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M426.737 241.969C434.037 234.669 445.856 234.669 453.156 241.969",
    stroke: "#474193",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479.574 241.969C486.874 234.669 498.693 234.669 505.993 241.969",
    stroke: "#474193",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M489.252 277.676L490.504 277.328C500.807 274.505 509.998 268.596 516.839 260.392C518.41 258.515 521.413 259.071 522.206 261.38C524.806 268.93 526.753 280.943 517.729 287.534C504.061 297.531 492.409 287.715 487.765 282.82C486.138 281.11 486.958 278.287 489.239 277.662L489.252 277.676Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_263_929)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M394.577 285.003L396.246 281.875C397.511 279.511 400.626 278.593 402.795 280.178C402.948 280.289 407.3 288.368 410.484 290.787C413.988 293.443 420.926 293.763 427.03 287.909C435.123 280.15 436.096 267.942 441.63 263.062C451.349 254.483 463.071 255.901 471.191 262.951C479.311 270 480.98 283.07 475.223 292.233C469.494 301.369 449.236 312.214 438.905 315.162C426.224 318.777 413.585 312.951 408.037 308.696C399.166 301.925 393.284 291.496 393.284 291.496C390.809 289.077 392.492 286.477 394.591 285.003H394.577Z",
    fill: "url(#paint6_linear_263_929)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_263_929",
    x: 394.752,
    y: 272.38,
    width: 149.734,
    height: 136.778,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.258824 0 0 0 0 0 0 0 0 0 0.509804 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_263_929"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_263_929",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_263_929",
    x: 384.672,
    y: 167.446,
    width: 164.777,
    height: 160.718,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.258824 0 0 0 0 0 0 0 0 0 0.509804 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_263_929"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_263_929",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_263_929",
    x: 448.424,
    y: 171,
    width: 35.082,
    height: 36.5137,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.258824 0 0 0 0 0 0 0 0 0 0.509804 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_263_929"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_263_929",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_263_929",
    x: 384.053,
    y: 252.135,
    width: 102.576,
    height: 75.1592,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.258824 0 0 0 0 0 0 0 0 0 0.509804 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_263_929"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_263_929",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_263_929",
    x1: 469.639,
    y1: 277.388,
    x2: 469.637,
    y2: 398.151,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A185FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#AD95FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9B8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_263_929",
    x1: 532.507,
    y1: 292.633,
    x2: 532.507,
    y2: 354.925,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A185FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9B8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_263_929",
    x1: 375.56,
    y1: 346.762,
    x2: 396.794,
    y2: 304.267,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A185FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9B8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_263_929",
    x1: 424.151,
    y1: 231.93,
    x2: 364.863,
    y2: 231.93,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A185FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9B8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_263_929",
    x1: 509.956,
    y1: 231.93,
    x2: 569.259,
    y2: 231.93,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A185FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9B8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_263_929",
    x1: 467.061,
    y1: 317.164,
    x2: 467.061,
    y2: 172.446,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A185FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9B8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_263_929",
    x1: 472.064,
    y1: 263.445,
    x2: 404.965,
    y2: 309.252,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A185FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#A990FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#BBA6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#C5B3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9B8FF"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMascotte2);
export default __webpack_public_path__ + "static/media/mascotte2.1429ca08dc4522b8defb4b55e5a83ea5.svg";
export { ForwardRef as ReactComponent };